import PageHeadline from '../../../components/molecules/headlines/PageHeadline.vue'
import AccountIconWh104 from '../../../components/atoms/account_icons/AccountIconWh104.vue'
export default {
  components: { PageHeadline, AccountIconWh104 },
  data() {
    return {
      isInfoPublicChecked: true
    }
  },
  mounted() {
    const infoPublic = document.querySelector('#info_public').value

    if (infoPublic === 'false') {
      this.isInfoPublicChecked = false
    }
  }
}
